import React from 'react';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import type { SvgIconProps } from '@mui/material/SvgIcon';

export function BackArrowIcon(props: SvgIconProps) {
  return <KeyboardBackspaceIcon data-cy="backArrowIcon" {...props} />;
}
